import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getBlacklistTemplate,
  TemplateType,
  getRestrictedlistAreas,
  deleteRestrictedlistAddressByLocationID,
  postBulkUploadIsochroneRestrictedlistArea,
  postBulkUploadCSVRestrictedlistArea,
} from 'features/Location/services/greylistArea'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastFailed, toastSuccess } from 'utils/toast'
import { downloadFileBlob } from 'utils/downloadFileUrl'
import { SLICE_NAME, setIsLoading, setBlackListSummary, setModal } from './slice'

export const fetchGreylistAreas = createAsyncThunk(
  `${SLICE_NAME}/fetchServiceLevelList`,
  async (_, { dispatch, getState, rejectWithValue }) => {
    const {
      greylistAreaList: { query },
    } = getState() as StoreStateType

    dispatch(setIsLoading(true))
    try {
      const { data } = await getRestrictedlistAreas({
        params: { limit: query.limit, page: query.page, location_name: query.location_name },
      })

      if (data.error?.status) {
        toastFailed(data.error.message)
      } else {
        dispatch(
          setBlackListSummary(
            data.data.restricted_address_summary.map((el) => ({
              ...el,
              uniqueID: window.crypto.randomUUID(),
            })),
          ),
        )
      }

      dispatch(setIsLoading(false))
      return data
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const removeBlacklistAreasByLocationID = createAsyncThunk(
  `${SLICE_NAME}/removeBlacklistAreasByLocationID`,
  async ({ id }: { id: string }, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await deleteRestrictedlistAddressByLocationID({
        location_id: id,
      })

      if (data.error?.status) {
        toastFailed(data.error.message)
      } else {
        toastSuccess(data.data.message)
      }

      dispatch(setIsLoading(false))
      return data
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const uploadCsvBlacklistArea = createAsyncThunk(
  `${SLICE_NAME}/uploadCsvBlacklistArea`,
  async ({ payload }: { payload: FormData }, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))

    try {
      const { data } = await postBulkUploadCSVRestrictedlistArea({
        data: payload,
      })

      if (data.error?.status) {
        toastFailed(data.error.message)
      } else {
        toastSuccess(
          `sukses ${data.data.success_data}, gagal ${data.data.failed_data}, total data ${data.data.total_data}`,
        )
        dispatch(setModal({ file: null, mode: '' }))
      }

      dispatch(setIsLoading(false))
      return data
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

export const uploadIsochroneBlacklistArea = createAsyncThunk(
  `${SLICE_NAME}/uploadIsochroneBlacklistArea`,
  async ({ payload }: { payload: FormData }, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))

    try {
      const { data } = await postBulkUploadIsochroneRestrictedlistArea({
        data: payload,
      })

      if (data.error?.status) {
        toastFailed(data.error.message)
      } else {
        const toastMessage = `Data Sukses ${data.data.success_data}, Data Gagal ${data.data.failed_data}, Total Data ${data.data.total_data}`

        if (data.data.status === 'Failed') {
          toastFailed(toastMessage)
        } else {
          toastSuccess(toastMessage)
          dispatch(setModal({ file: null, mode: '' }))
        }
      }

      dispatch(setIsLoading(false))
      return data
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)

const getMimeType = (type: TemplateType) => {
  if (
    type === 'template-update-blacklist-isochrone' ||
    type === 'template-create-blacklist-isochrone'
  ) {
    return 'application/geojson'
  }

  return 'text/csv'
}

export const fetchBlacklistTemplate = createAsyncThunk(
  `${SLICE_NAME}/fetchBlacklistTemplate`,
  async ({ type }: { type: TemplateType }, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))
    try {
      const { data } = await getBlacklistTemplate({
        type,
      })

      if (data.error?.status) {
        toastFailed(data.error.message)
      } else {
        downloadFileBlob({
          data: data.data.file_byte,
          fileName: data.data.filename,
          mimeType: getMimeType(type),
        })
      }

      dispatch(setIsLoading(false))
      return data
    } catch (err) {
      dispatch(setIsLoading(false))
      callErrorMsg(err)
      return rejectWithValue(err)
    }
  },
)
